import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './Pricing299.css';

/**
 * Страница для плана Basic ($299)
 */
const Pricing299 = () => {
  const navigate = useNavigate();

  const sections = [
    { id: 'hero', label: 'Home' },
    { id: 'testimonial', label: 'About Us' },
    { id: 'legal-help', label: 'Services' },
    { id: 'success-stories', label: 'Success Stories' },
    { id: 'features', label: 'Features' }
  ];

  return (
    <div className="pricing-299-page">
      <Header sections={sections} onJoinClick={() => navigate('/contact-form')} />
      
      <main className="pricing-299-container">
        <div className="pricing-299-box">
          <div className="pricing-299-icon">✅</div>
          <h1 className="pricing-299-title">Basic Plan Selected</h1>
          <p className="pricing-299-subtitle">
            You have selected the Basic plan for $299
          </p>
          <div className="pricing-299-details">
            <h3>Your plan includes:</h3>
            <ul>
              <li>Basic financial management recommendations</li>
              <li>Personalized assistance from our experts</li>
              <li>One-time debt analysis report</li>
            </ul>
          </div>
          <button 
            className="pricing-299-button"
            onClick={() => navigate('/contact-form')}
          >
            Continue to Payment
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Pricing299;
